import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import { useSharedActions, useSharedDispatch, useSharedSelector } from "../../../../store/SharedProvider";
import {
  selectGeneratingTeachPathMessage,
  selectIsGeneratingTeachPath,
  selectSelectedZoneInstance,
  selectTeachAndRepeatPath,
} from "../../../../store/room/zone-planner/zone-planner-selectors";
import CustomSnackbar from "../../../Feedback/CustomSnackbar";
import CustomLoader from "../../../Feedback/CustomLoader";
import { isCleaningZone } from "../../../../interfaces/robot/rooms/cleaning-zone";
import Backdrop from "@mui/material/Backdrop";
import { TeachingUpdateType } from "../../../../interfaces/robot/rooms/hub-messages/teaching-update-message";
import HttpFetchStatus from "../../../../enums/api/http-fetch-status";
import { selectRepeatPathsData } from "../../../../store/room/room-selectors";

const TeachAndRepeatZoneGeneratingPathState: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useSharedDispatch();

  const { patchCleaningZone, resetGeneratingTeachPathMessage } = useSharedActions();

  const generatingTeachPathMessage = useSharedSelector((state) => selectGeneratingTeachPathMessage(state));
  const isGeneratingTeachPath = useSharedSelector((state) => selectIsGeneratingTeachPath(state));
  const selectedZoneInstance = useSharedSelector((state) => selectSelectedZoneInstance(state));
  const selectedTrPathInstance = useSharedSelector((state) => selectTeachAndRepeatPath(state));

  useEffect(() => {
    if (
      isGeneratingTeachPath &&
      generatingTeachPathMessage != null &&
      selectedZoneInstance != null &&
      isCleaningZone(selectedZoneInstance) &&
      selectedTrPathInstance != null &&
      selectedTrPathInstance.path != null
    ) {
      if (generatingTeachPathMessage.type === TeachingUpdateType.AutoGeneratePathSuccess) {
        dispatch(patchCleaningZone({ id: selectedTrPathInstance.zoneId, data: {teachAndRepeatPath: { path: selectedTrPathInstance.path.map(pt => ({...pt})) }} }));
        dispatch(resetGeneratingTeachPathMessage());
      }
    }
  }, [
    dispatch,
    generatingTeachPathMessage,
    patchCleaningZone,
    resetGeneratingTeachPathMessage,
    isGeneratingTeachPath,
    selectedZoneInstance,
    selectedTrPathInstance,
  ]);

  const closeErrorSnackbarHandler = () => {
    dispatch(resetGeneratingTeachPathMessage());
  };

  if (isGeneratingTeachPath && generatingTeachPathMessage == null) {
    return ReactDOM.createPortal(
      <Backdrop open={true} sx={(theme) => ({ zIndex: theme.zIndex.modal + 1, color: "white" })}>
        <CustomLoader loadingMessage={t("teachingwizard-generating-path")} />
      </Backdrop>,
      document.body
    );
  } else if (
    generatingTeachPathMessage != null &&
    generatingTeachPathMessage.type === TeachingUpdateType.AutoGeneratePathError
  ) {
    return ReactDOM.createPortal(
      <CustomSnackbar
        title={t("teachingwizard-error-autogenerating-path")}
        open
        onClose={closeErrorSnackbarHandler}
        severity="error"
      />,
      document.body
    );
  }

  return null;
};

export default TeachAndRepeatZoneGeneratingPathState;
